import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AppNetworkEgressCategory, AppNetworkPermissionType, EcosystemGlobalInstallationOverrideKeys } from '@atlassian/mpac-types/graphql-gateway-types';
export const RoaTrustSignalRules = {
  HAS_EGRESS_WEBTRIGGER_MODULE: 'HAS_EGRESS_WEBTRIGGER_MODULE'
};
export const getAppRoaStatus = latestVersionAppDetailsResult => {
  var _latestVersionAppDeta, _latestVersionAppDeta2, _latestVersionAppDeta3, _latestVersionAppDeta4, _latestVersionAppDeta5;
  return latestVersionAppDetailsResult === null || latestVersionAppDetailsResult === void 0 ? void 0 : (_latestVersionAppDeta = latestVersionAppDetailsResult.app) === null || _latestVersionAppDeta === void 0 ? void 0 : (_latestVersionAppDeta2 = _latestVersionAppDeta.environmentByKey) === null || _latestVersionAppDeta2 === void 0 ? void 0 : (_latestVersionAppDeta3 = _latestVersionAppDeta2.versions) === null || _latestVersionAppDeta3 === void 0 ? void 0 : (_latestVersionAppDeta4 = _latestVersionAppDeta3.nodes) === null || _latestVersionAppDeta4 === void 0 ? void 0 : (_latestVersionAppDeta5 = _latestVersionAppDeta4[0]) === null || _latestVersionAppDeta5 === void 0 ? void 0 : _latestVersionAppDeta5.runsOnAtlassian.result;
};
export const checkIfGlobalLogsAndAnalyticsAreEnabled = globalInstallationConfigResult => {
  var _globalInstallationCo, _globalInstallationCo2, _globalInstallationCo3;
  /* if globalInstallationConfig is not present, we assume it is enabled
   if globalInstallationConfig is present but empty, we assume it is enabled */
  if (!(globalInstallationConfigResult !== null && globalInstallationConfigResult !== void 0 && (_globalInstallationCo = globalInstallationConfigResult.ecosystem) !== null && _globalInstallationCo !== void 0 && _globalInstallationCo.globalInstallationConfig) || (globalInstallationConfigResult === null || globalInstallationConfigResult === void 0 ? void 0 : globalInstallationConfigResult.ecosystem.globalInstallationConfig.length) === 0) {
    return true;
  }
  const analyticsSettings = (_globalInstallationCo2 = globalInstallationConfigResult.ecosystem.globalInstallationConfig.find(eachConfig => (eachConfig === null || eachConfig === void 0 ? void 0 : eachConfig.key) === EcosystemGlobalInstallationOverrideKeys.AllowEgressAnalytics)) === null || _globalInstallationCo2 === void 0 ? void 0 : _globalInstallationCo2.value;
  const logsSettings = (_globalInstallationCo3 = globalInstallationConfigResult.ecosystem.globalInstallationConfig.find(eachConfig => (eachConfig === null || eachConfig === void 0 ? void 0 : eachConfig.key) === EcosystemGlobalInstallationOverrideKeys.AllowLogsAccess)) === null || _globalInstallationCo3 === void 0 ? void 0 : _globalInstallationCo3.value;
  // If the settings are not present, we assume they are enabled
  if (analyticsSettings === undefined || logsSettings === undefined) {
    return true;
  }
  return !!analyticsSettings && !!logsSettings;
};
/**
 * Formats a list of URLs by extracting the unique base addresses (protocol and host) or keeping the full path if they differ.
 *
 * @param {string[]} addresses - An array of URLs as strings.
 * @param {function} formatMessage - returns localized string for cases like "All subdomains"
 * @returns {string[]} An array of formatted URLs as strings.
 * Example 1: ['https://example.com/', 'https://example.com/path2', 'https://example.com/path1'] ==> returns ['https://example.com/']
 * Example 2: ['http://example.com/path1', 'https://example.com/path1'] ==> returns ['http://example.com/path1', 'https://example.com/path1']
 * Example 3: ['*.posthog.com', '*.example.com'] ==> returns ['All subdomains of posthog.com', 'All subdomains of example.com']
 * Refer: https://hello.atlassian.net/wiki/spaces/ECO/pages/4851672538/WIP+Data+egress+disclosure+UI+content
 */

export const formatEgressAddress = addresses => {
  const uniqueDomains = {};
  let uniqueAddresses = [];
  addresses.forEach(eachAddress => {
    /* case: address starts with asterisk */
    if (eachAddress.startsWith('*.')) {
      const domain = eachAddress.replace('*.', '');
      uniqueDomains[domain] = true;
      uniqueAddresses.push("All subdomains of ".concat(domain));
    } else {
      try {
        const url = new URL(eachAddress);
        const baseAddress = "".concat(url.protocol, "//").concat(url.host);
        uniqueAddresses.push(url);
        if (!uniqueDomains[baseAddress]) {
          /* domain is not unique/overall */
          // eslint-disable-next-line max-depth
          if (url.pathname === '/' || url.pathname === '') {
            uniqueDomains[baseAddress] = true;
          }
        }
      } catch (_unused) {
        /* in case the url is wrongly formatted and new URL(eachAddress); fails */
        uniqueAddresses.push(eachAddress);
      }
    }
  });
  Object.keys(uniqueDomains).forEach(eachUniqueDomain => {
    uniqueAddresses = uniqueAddresses.filter(currUniqueUrlEach => {
      if (currUniqueUrlEach instanceof URL) {
        if ("".concat(currUniqueUrlEach.protocol, "//").concat(currUniqueUrlEach.host) === eachUniqueDomain && currUniqueUrlEach.pathname.length > 1) {
          return false;
        }
        return true;
      }
      return true;
    });
  });
  return [...new Set(uniqueAddresses.map(eachAddress => eachAddress instanceof URL ? decodeURI(eachAddress.href) : eachAddress))];
};
export const filterRemoteEgressAndAnalytics = egresses => {
  const analyticsEgress = [];
  const remoteEgress = [];
  egresses.forEach(eachEgress => {
    if (eachEgress.category === AppNetworkEgressCategory.Analytics) {
      analyticsEgress.push(eachEgress);
    } else {
      remoteEgress.push(eachEgress);
    }
  });
  return {
    remoteEgress,
    analyticsEgress
  };
};
export const IN_SCOPE_EUD_CHANGES = {
  INCLUDED: 'INCLUDED',
  EXCLUDED: 'EXCLUDED'
};
export const getInScopeEudForAnalyticsEgress = analyticsEgress => {
  const analyticsEgressInScopeEUD = analyticsEgress.every(each => each.inScopeEUD === false);
  /* If any of the element has inScopeEUD as true or null, we would show INCLUDED */
  if (analyticsEgressInScopeEUD) {
    return IN_SCOPE_EUD_CHANGES.EXCLUDED;
  }
  return IN_SCOPE_EUD_CHANGES.INCLUDED;
};

/**
 * Categorizes egress and analytics data from the latest version of app details.
 * @param {LatestAppVersionDetailsQuery | undefined} latestVersionAppDetailsResult - The result of the latest app version details query.
 * @returns {{
 *   categorizedRemoteEgress: FormattedRemoteEgress;
 *   analyticsEgress: string[];
 *   inScopeEUDForLatestVersion: string;
 * }} An object containing:
 * - `categorizedRemoteEgress`: A mapping of egress types to their corresponding addresses.
 * Example categorizedRemoteEgress: {
 *  [AppNetworkPermissionType.Fonts]: ['https://example-fonts.com'],
 *  [AppNetworkPermissionType.Scripts]: ['https://example-scripts.com'],
 * }
 * - `analyticsEgress`: A flat array of analytics egress addresses.
 * - `inScopeEUDForLatestVersion`: A string indicating whether the analytics egress is in scope for EUD changes (`INCLUDED` or `EXCLUDED`).
 */

export const getCategorizedEgressAndAnalytics = latestVersionAppDetailsResult => {
  var _latestVersionAppDeta6, _latestVersionAppDeta7, _latestVersionAppDeta8, _latestVersionAppDeta9, _latestVersionAppDeta10, _latestVersionAppDeta11, _latestVersionAppDeta12;
  const egresses = latestVersionAppDetailsResult === null || latestVersionAppDetailsResult === void 0 ? void 0 : (_latestVersionAppDeta6 = latestVersionAppDetailsResult.app) === null || _latestVersionAppDeta6 === void 0 ? void 0 : (_latestVersionAppDeta7 = _latestVersionAppDeta6.environmentByKey) === null || _latestVersionAppDeta7 === void 0 ? void 0 : (_latestVersionAppDeta8 = _latestVersionAppDeta7.versions) === null || _latestVersionAppDeta8 === void 0 ? void 0 : (_latestVersionAppDeta9 = _latestVersionAppDeta8.nodes) === null || _latestVersionAppDeta9 === void 0 ? void 0 : (_latestVersionAppDeta10 = _latestVersionAppDeta9[0]) === null || _latestVersionAppDeta10 === void 0 ? void 0 : (_latestVersionAppDeta11 = _latestVersionAppDeta10.permissions) === null || _latestVersionAppDeta11 === void 0 ? void 0 : (_latestVersionAppDeta12 = _latestVersionAppDeta11[0]) === null || _latestVersionAppDeta12 === void 0 ? void 0 : _latestVersionAppDeta12.egress;
  if (!(egresses !== null && egresses !== void 0 && egresses.length)) {
    return {
      formattedRemoteEgress: {},
      analyticsEgress: []
    };
  }
  const {
    remoteEgress,
    analyticsEgress
  } = filterRemoteEgressAndAnalytics(egresses);
  const inScopeEUDForLatestVersion = getInScopeEudForAnalyticsEgress(analyticsEgress);
  const categorizedRemoteEgress = Object.values(AppNetworkPermissionType).reduce((acc, currEgressType) => {
    var _egressInCurrCategory;
    const egressInCurrCategory = remoteEgress === null || remoteEgress === void 0 ? void 0 : remoteEgress.filter(egress => egress.type === currEgressType);
    const allAddresses = egressInCurrCategory === null || egressInCurrCategory === void 0 ? void 0 : (_egressInCurrCategory = egressInCurrCategory.map(each => each.addresses)) === null || _egressInCurrCategory === void 0 ? void 0 : _egressInCurrCategory.flat();
    return _objectSpread(_objectSpread({}, acc), {}, {
      [currEgressType]: allAddresses
    });
  }, {});
  return {
    categorizedRemoteEgress,
    analyticsEgress: analyticsEgress.map(each => each.addresses || []).flat(),
    inScopeEUDForLatestVersion
  };
};
export const findWebTriggerRule = latestVersionAppDetailsResult => {
  var _latestVersionAppDeta13, _latestVersionAppDeta14, _latestVersionAppDeta15, _latestVersionAppDeta16, _latestVersionAppDeta17, _latestVersionAppDeta18, _latestVersionAppDeta19, _webTriggerRule$value;
  const webTriggerRule = latestVersionAppDetailsResult === null || latestVersionAppDetailsResult === void 0 ? void 0 : (_latestVersionAppDeta13 = latestVersionAppDetailsResult.app) === null || _latestVersionAppDeta13 === void 0 ? void 0 : (_latestVersionAppDeta14 = _latestVersionAppDeta13.environmentByKey) === null || _latestVersionAppDeta14 === void 0 ? void 0 : (_latestVersionAppDeta15 = _latestVersionAppDeta14.versions) === null || _latestVersionAppDeta15 === void 0 ? void 0 : (_latestVersionAppDeta16 = _latestVersionAppDeta15.nodes) === null || _latestVersionAppDeta16 === void 0 ? void 0 : (_latestVersionAppDeta17 = _latestVersionAppDeta16[0]) === null || _latestVersionAppDeta17 === void 0 ? void 0 : (_latestVersionAppDeta18 = _latestVersionAppDeta17.runsOnAtlassian) === null || _latestVersionAppDeta18 === void 0 ? void 0 : (_latestVersionAppDeta19 = _latestVersionAppDeta18.rules) === null || _latestVersionAppDeta19 === void 0 ? void 0 : _latestVersionAppDeta19.find(each => each.name === RoaTrustSignalRules.HAS_EGRESS_WEBTRIGGER_MODULE);
  return (_webTriggerRule$value = webTriggerRule === null || webTriggerRule === void 0 ? void 0 : webTriggerRule.value) !== null && _webTriggerRule$value !== void 0 ? _webTriggerRule$value : false;
};